import { render, staticRenderFns } from "./LessonGroupResults.vue?vue&type=template&id=bca08abc"
import script from "./LessonGroupResults.vue?vue&type=script&lang=js"
export * from "./LessonGroupResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports